/** @jsxImportSource @emotion/react */
import Checkbox from '../checkbox/Checkbox';
import RadioButton from '../checkbox/RadioButton';
import * as s from './style';
import React, { useEffect, useState } from 'react';
import { PieChart } from '@mui/x-charts/PieChart';
import DateSlider from './DateSlider';
import dayjs from 'dayjs';

const OptionMenu = ({
    mode,
    selectedRadioOption,
    setSelectedRadioOption,
    pointVectorLayerVisible,
    setPointVectorLayerVisible,
    mapData,
    selectedSubArray,
    status,
}) => {
    const classifications = [
        'EqInterval',
        'StdDeviation',
        'ArithmeticProgression',
        'GeometricProgression',
        'Quantile',
        'Jenks',
    ];
    const areaSelects = ['circle', 'extent', 'draw'];

    const [chartData, setChartData] = useState([]);
    const [minDate, setMinDate] = useState({
        value: dayjs('2022-01'),
        minValue: dayjs('2020-01'),
        maxValue: dayjs('2022-01'),
        default: 0,
    });
    const [maxDate, setMaxDate] = useState({
        value: dayjs('2022-01'),
        minValue: dayjs('2020-01'),
        maxValue: dayjs('2022-01'),
        default: 288,
    });
    const [currentDate, setCurrentDate] = useState({
        value: dayjs('2020-01'),
        minValue: dayjs('2020-01'),
        maxValue: dayjs('2022-01'),
        default: 0,
    });

    useEffect(() => {
        if (mode === 'hexBinMap') {
            setSelectedRadioOption('EqInterval');
        }

        if (mode === 'pointTimeMap') {
            setMinDate({
                value: dayjs('2020-01'),
                minValue: dayjs('2020-01'),
                maxValue: dayjs('2020-12'),
                default: 0,
            });

            setMaxDate({
                value: dayjs('2020-12'),
                minValue: dayjs('2020-01'),
                maxValue: dayjs('2020-12'),
                default: 12,
            });

            setCurrentDate({
                value: dayjs('2020-01'),
                minValue: dayjs('2020-01'),
                maxValue: dayjs('2020-12'),
                default: 0,
            });
        } else if (mode === 'circleTimeMap') {
            setMinDate({
                value: dayjs('2020-01'),
                minValue: dayjs('2020-01'),
                maxValue: dayjs('2022-12'),
                default: 0,
            });

            setMaxDate({
                value: dayjs('2022-12'),
                minValue: dayjs('2020-01'),
                maxValue: dayjs('2022-12'),
                default: 12,
            });

            setCurrentDate({
                value: dayjs('2020-01'),
                minValue: dayjs('2020-01'),
                maxValue: dayjs('2022-12'),
                default: 0,
            });
        }
    }, [mode]);

    useEffect(() => {
        if (mapData) {
            const uniqueIds = Array.from(new Set(mapData.map((data) => data.get('id'))));

            const newChartData = uniqueIds.map((id) => {
                const filteredData = mapData.filter((data) => data.get('id') === id);
                const sub = selectedSubArray.find((sub) => sub.id === id);
                return { id: id, value: filteredData.length, color: filteredData[0].get('COLOR'), label: sub.name };
            });

            setChartData(newChartData);
        } else {
            setChartData([]);
        }
    }, [mapData]);

    return (
        <div css={s.mainContainer}>
            {mode === 'hexBinMap' && (
                <div>
                    <div css={s.option}>
                        <span css={s.optionName}>HexBin Size</span>
                        <div css={s.swiper}>
                            <input
                                id="sizeSwiper"
                                type="range"
                                min={1000}
                                max={20000}
                                defaultValue={10000}
                                step={1000}
                                onInput={(e) => {
                                    document.getElementById('sizeLabel').innerText = e.target.value;
                                }}
                            />
                            <span css={s.distanceLabel} id="sizeLabel">
                                {10000}
                            </span>
                        </div>
                    </div>

                    {classifications.length > 0 && (
                        <>
                            {classifications.map((classification, idx) => (
                                <RadioButton
                                    key={idx}
                                    name={classification}
                                    checked={classification === selectedRadioOption}
                                    onChange={() => setSelectedRadioOption(classification)}
                                />
                            ))}
                        </>
                    )}

                    {/* <div css={s.optionList('row')}> */}
                    <div css={s.divider}></div>
                    <Checkbox
                        name={'Display Point'}
                        checked={pointVectorLayerVisible}
                        onChange={() => setPointVectorLayerVisible(!pointVectorLayerVisible)}
                    />
                    {/* </div> */}
                </div>
            )}
            {mode === 'clusterMap' && (
                <div>
                    <div css={s.option}>
                        <span css={s.optionName}>Cluster distance</span>
                        <div css={s.swiper}>
                            <input
                                id="distanceSwiper"
                                type="range"
                                min={0}
                                max={100}
                                defaultValue={40}
                                step={1}
                                onInput={(e) => {
                                    document.getElementById('distanceLabel').innerText = e.target.value;
                                }}
                            />
                            <span css={s.distanceLabel} id="distanceLabel">
                                {40}
                            </span>
                        </div>
                    </div>
                    <div css={s.option}>
                        <span css={s.optionName}>Minimum distance</span>
                        <div css={s.swiper}>
                            <input
                                id="min-distanceSwiper"
                                type="range"
                                min={0}
                                max={100}
                                defaultValue={20}
                                step={1}
                                onInput={(e) => {
                                    document.getElementById('min-distanceLabel').innerText = e.target.value;
                                }}
                            />
                            <span css={s.distanceLabel} id="min-distanceLabel">
                                {20}
                            </span>
                        </div>
                    </div>

                    <div css={s.divider}></div>
                    {/* <div css={s.optionList('row')}> */}
                    <Checkbox
                        name={'Display Point'}
                        checked={pointVectorLayerVisible}
                        onChange={() => setPointVectorLayerVisible(!pointVectorLayerVisible)}
                    />
                    {/* </div> */}
                </div>
            )}
            {mode === 'heatMap' && (
                <div>
                    <div css={s.option}>
                        <span css={s.optionName}>Radius size</span>
                        <div css={s.swiper}>
                            <input
                                id="radiusSwiper"
                                type="range"
                                min={1}
                                max={30}
                                defaultValue={1}
                                step={1}
                                onInput={(e) => {
                                    document.getElementById('radiusLabel').innerText = e.target.value;
                                }}
                            />
                            <span css={s.distanceLabel} id="radiusLabel">
                                {1}
                            </span>
                        </div>
                    </div>
                    <div css={s.option}>
                        <span css={s.optionName}>Blur size</span>
                        <div css={s.swiper}>
                            <input
                                id="blurSwiper"
                                type="range"
                                min={1}
                                max={30}
                                defaultValue={10}
                                step={1}
                                onInput={(e) => {
                                    document.getElementById('blurLabel').innerText = e.target.value;
                                }}
                            />
                            <span css={s.distanceLabel} id="blurLabel">
                                {10}
                            </span>
                        </div>
                    </div>

                    <div css={s.divider}></div>
                    {/* <div css={s.optionList('row')}> */}
                    <Checkbox
                        name={'Display Point'}
                        checked={pointVectorLayerVisible}
                        onChange={() => setPointVectorLayerVisible(!pointVectorLayerVisible)}
                    />
                    {/* </div> */}
                </div>
            )}
            {mode === 'pointStatisticsMap' && (
                <div>
                    {areaSelects.length > 0 && (
                        <>
                            {areaSelects.map((select, idx) => (
                                <RadioButton
                                    key={idx}
                                    name={select}
                                    checked={select === selectedRadioOption}
                                    onChange={() => setSelectedRadioOption(select)}
                                />
                            ))}
                        </>
                    )}

                    {/* {chartData.length > 0 && (
                        <div css={s.optionList()}>
                            <PieChart
                                series={[
                                    {
                                        data: chartData,
                                        innerRadius: 60,
                                        outerRadius: 100,
                                        cy: 120,
                                    },
                                ]}
                                width={400}
                                height={400}
                                slotProps={{
                                    legend: {
                                        direction: 'row',
                                        position: { vertical: 'bottom', horizontal: 'middle' },
                                        padding: 0,
                                        labelStyle: {
                                            fontSize: '14px',
                                        },
                                        itemMarkHeight: 15,
                                        itemMarkWidth: 15,
                                    },
                                }}
                            />
                        </div>
                    )} */}
                </div>
            )}
            {mode === 'pointTimeMap' && (
                <div>
                    <div css={s.option}>
                        <span css={s.optionName}>Minimum date</span>
                        <DateSlider
                            id={'minDate'}
                            date={minDate}
                            setDate={setMinDate}
                            minDate={minDate}
                            maxDate={maxDate}
                        />
                    </div>
                    <div css={s.option}>
                        <span css={s.optionName}>Maximum date</span>
                        <DateSlider
                            id={'maxDate'}
                            date={maxDate}
                            setDate={setMaxDate}
                            minDate={minDate}
                            maxDate={maxDate}
                        />
                    </div>
                    <div css={s.option}>
                        <span css={s.optionName}>Interval</span>
                        <div css={s.swiper}>
                            <input
                                id="intervalSwiper"
                                type="range"
                                min={100}
                                max={5000}
                                defaultValue={500}
                                step={100}
                                onInput={(e) => {
                                    document.getElementById('intervalLabel').innerText = e.target.value;
                                }}
                            />
                            <span css={s.distanceLabel} id="intervalLabel">
                                {500}
                            </span>
                        </div>
                    </div>
                    <div css={s.option}>
                        <span css={s.optionName}>Current date</span>
                        <DateSlider
                            id={'currentDate'}
                            date={currentDate}
                            setDate={setCurrentDate}
                            minDate={minDate}
                            maxDate={maxDate}
                        />
                    </div>
                    <div css={s.option}>
                        <div>
                            <button id="intervalStartButton" css={[s.button, status ? null : s.disabled]}>
                                start
                            </button>
                            <button id="intervalStopButton" css={s.button}>
                                stop
                            </button>
                            <button id="intervalResetButton" css={s.button}>
                                reset
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {mode === 'circleTimeMap' && (
                <div>
                    <div css={s.option}>
                        <span css={s.optionName}>Minimum date</span>
                        <DateSlider
                            id={'minDate'}
                            date={minDate}
                            setDate={setMinDate}
                            minDate={minDate}
                            maxDate={maxDate}
                        />
                    </div>
                    <div css={s.option}>
                        <span css={s.optionName}>Maximum date</span>
                        <DateSlider
                            id={'maxDate'}
                            date={maxDate}
                            setDate={setMaxDate}
                            minDate={minDate}
                            maxDate={maxDate}
                        />
                    </div>
                    <div css={s.option}>
                        <span css={s.optionName}>Current date</span>
                        <DateSlider
                            id={'currentDate'}
                            date={currentDate}
                            setDate={setCurrentDate}
                            minDate={minDate}
                            maxDate={maxDate}
                        />
                    </div>
                    <div css={s.option}>
                        <p css={s.optionName}>
                            <span>Cluster Size: </span>
                            <span id="clusterSize" />
                        </p>
                    </div>
                    <div css={s.option}>
                        <div>
                            <button id="intervalStartButton" css={[s.button, status ? null : s.disabled]}>
                                start
                            </button>
                            <button id="intervalStopButton" css={s.button}>
                                stop
                            </button>
                            <button id="intervalResetButton" css={s.button}>
                                reset
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default OptionMenu;
